<template>
    <div>
        
        <div class="placeholder">
            <div class="placeholder__heading">
                Opgaver uden budget ({{ rows ? rows.length : '-' }})
            </div>
            <div class="placeholder">
                
                <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    :searchOptions="searchOptions"
                    :paginationOptions="paginationOptions"
                    :sortOptions="sortOptions"
                    styleClass="vgt-table"
                    v-if="!loading"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div v-if="props.column.field == 'description'" class="table-column__description" :title="props.row.description">
                            {{ props.row.description }}
                        </div>
                        <div v-else-if="props.column.field == 'customer.name'" class="table-column__customer" :title="props.row.customer ? props.row.customer.name : '-'">
                            <i class="fal fa-map-marker-alt" style="margin-left:2px;" v-tooltip="{
                                content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
                            }" v-if="props.row.installation_address"></i>
                            {{ props.row.customer ? props.row.customer.name : '-' }}
                        </div>
                        <div v-else-if="props.column.field == 'start_date'">
                            {{ props.row.start_date | moment("DD. MMM YYYY") }}
                        </div>
                        <div class="coverage-cell" v-else-if="props.column.field == 'status.name'">
                            {{ props.row.status.name }}
                            <div class="coverage-indicator status" :style="'background:#' + props.row.status.color + ';'" />
                        </div>
                        <div v-else-if="props.column.field == 'minuba_external_id'">
                            <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                                <i class="fas fa-eye"></i>
                            </a>
                        </div>
                        <div v-else :title="props.formattedRow[props.column.field]">
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>

                <box-loading height="350" v-else />

            </div>
        </div>

    </div>
</template>

<script>
import * as projectService from '@/services/projectService'

export default {
    data () {
        return {
            loading: true,
            columns: [
                { label: 'Ordre', field: 'case_number' },
                { label: 'Opgave', field: 'description' },
                { label: 'Kunde', field: 'customer.name' },
                { label: 'Startdato', field: 'start_date' },
                { label: 'Status', field: 'status.name' }
            ],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'case_number',
                    type: 'asc'
                }
            }
        }
    },
    mounted () {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' })
        }
        this.getData()
    },
    methods: {
        getData () {
            let params = {
                'include': 'type,customer,status',
                'filter[status]': 'offer,pending,ongoing,unbilled',
                'filter[missingBudget]': 1
            }
            projectService.find(params, (response) => {
                this.rows = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// projectsMissingBudget.vue?463e10be